<template>
  <div class="history-container">
    <v-timeline dence>
      <v-timeline-item v-for="(item, index) in content" :key="index">
        <v-card>
          <v-card-title class="history-item-title">{{
            item.name
          }}</v-card-title>
          <v-card-text class="history-item-text">{{ item.text }}</v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>
<script>
export default {
  name: 'history',
  computed: {
    content: function () {
      return [
        {
          name: '1992',
          text: this.$t('history.1992')
        },
        {
          name: '1994',
          text: this.$t('history.1994')
        },
        {
          name: '1997',
          text: this.$t('history.1997')
        },
        {
          name: '1998',
          text: this.$t('history.1998')
        },
        {
          name: '1999',
          text: this.$t('history.1999')
        },
        {
          name: '2002',
          text: this.$t('history.2002')
        },
        {
          name: '2003',
          text: this.$t('history.2003')
        },
        {
          name: '2005',
          text: this.$t('history.2005')
        },
        {
          name: '2006',
          text: this.$t('history.2006')
        },
        {
          name: '2008',
          text: this.$t('history.2008')
        },
        {
          name: '2009',
          text: this.$t('history.2009')
        },
        {
          name: '2011',
          text: this.$t('history.2011')
        },
        {
          name: '2015',
          text: this.$t('history.2015')
        },
        {
          name: '2016',
          text: this.$t('history.2016')
        },
        {
          name: '2019',
          text: this.$t('history.2019(1)')
        },
        {
          name: '2019',
          text: this.$t('history.2019(2)')
        },
        {
          name: '2021',
          text: this.$t('history.2021(1)')
        },
        {
          name: '2021',
          text: this.$t('history.2021(2)')
        },
        {
          name: '2022',
          text: this.$t('history.2022')
        }
      ]
    }
  }
}
</script>
<style lang="scss">
.history-item-title {
  font-size: 3.8rem !important;
  line-height: 3.8rem !important;
}
.history-item-text {
  font-size: 1.6rem !important;
  line-height: 2.2rem !important;
}

.v-timeline-item__dot {
  z-index: 1;
}
</style>
